let color_dictionary = {};
async function loadColorDictionary() {
  try {
    const colorJsonUrl = document.getElementById('color-json-url')?.value;
    if (!colorJsonUrl) return;
    const response = await fetch(colorJsonUrl);
    if (!response.ok)
      throw new Error(
        `Erreur lors du chargement du dictionnaire: ${response.status}`
      );
    const data = await response.json();
    color_dictionary = data;
    window.color_dictionary = data;
  } catch (error) {
    console.error(
      'Erreur lors du chargement du dictionnaire de couleurs:',
      error
    );
  }
}
const SIZE = [
  'X-SMALL',
  'SMALL',
  'MEDIUM',
  'LARGE',
  'X-LARGE',
  'XX-LARGE',
  'MM',
  'SS',
];

$(function () {
    loadColorDictionary().then(() => {

  // Get current SKU
  const current_sku = $('input[type=hidden]#hidden-product-sku').val();
  const product_type = $('input[type=hidden]#hidden-product-type').val();
  const selected_options = {
    sku: current_sku,
    dress_size: '',
    dress_length: '',
    color: '',
  };

  // Get SessionStorage object
  const current_session = sessionStorage.getItem('selected_options');

  // Reinitilialize Session if SKU is different
  if (current_session && current_sku !== JSON.parse(current_session).sku) {
    sessionStorage.setItem(
      'selected_options',
      JSON.stringify(selected_options)
    );
  }

  // Variant options Event Listeners
  if ($('.product_single_form').length > 0) {
    if (product_type !== 'fabric') {
      setGlobalSku();
    }

    if ($('.product-form__selects.product-select--size').length > 0) {
      $(document).on(
        'change',
        '.product-form__selects.product-select--size select',
        function () {
          if ($(this).val() != '') {
            setGlobalSku($(this).val());
          }
        }
      );
    } else {
      document.arrive('.infinite-option-size-select select', function () {
        $(this).change(function (e) {
          if ($(this).val() != '') {
            setGlobalSku($(this).val());
          }
        });
      });
    }

    if ($('.product-form__selects.product-select--dress-length').length > 0) {
      $(document).on(
        'change',
        '.product-form__selects.product-select--dress-length select',
        function () {
          if ($(this).val() !== '') {
            setGlobalSku('', $(this).val());
          }
        }
      );
    }

    if ($('.colorSelector.form-control').length > 0) {
      $(document).on(
        'click keyup',
        '.colorSelector .swatch-element',
        async function (e) {
          if (e.type == 'click' || (e.type == 'keyup' && e.keyCode == 13)) {
            await setGlobalSku();
          }
        }
      );
    }
  }
});
})
async function setGlobalSku(dress_size = '', dress_length = '') {
  // Initialize variables
  const productionGlobalSkuProp = $(
    'input[type=hidden]#product-properties-global-sku'
  );
  const isRtw = $('#hidden-is-rtw').val();
  let globalSKU = {
    sku: $('input[type=hidden]#hidden-product-sku').val(),
    dress_size: '',
    dress_length: '',
    color: '',
  };

  // Get SessionStorage object
  const current_session = sessionStorage.getItem('selected_options');

  // Set each option value

  // Selected Color
  if (current_session && JSON.parse(current_session).color !== '') {
    globalSKU.color = await getColorCode(JSON.parse(current_session).color);
  } else {
    const selectedColor = getSelectedColor() !== false ? getSelectedColor() : 'Ivory';
    globalSKU.color = await getColorCode(selectedColor);
  }

  // Selected Size
  if (dress_size !== '' && dress_size !== null) {
    globalSKU.dress_size = isNumber(dress_size)
      ? dress_size
      : dress_size.toUpperCase();
  } else {
    globalSKU.dress_size =
      current_session && JSON.parse(current_session).dress_size !== ''
        ? isNumber(JSON.parse(current_session).dress_size)
          ? JSON.parse(current_session).dress_size
          : JSON.parse(current_session).dress_size
        : getSize();
  }

  // Selected Length
  if (dress_length !== '') {
    globalSKU.dress_length = dress_length == 'Standard' ? '' : '-XL';
  } else {
    globalSKU.dress_length =
      current_session && JSON.parse(current_session).dress_length !== ''
        ? JSON.parse(current_session).dress_length == 'Standard'
          ? ''
          : '-XL'
        : getDressLength();
  }

  // GlobalSKU.. ASSEMBLE!!
  if (isRtw == 'true') {
    productionGlobalSkuProp.val(globalSKU.sku);
  } else {
    if (globalSKU && globalSKU.sku) {
      globalSKU.sku = globalSKU.sku.split('-')[0]; // Remove last 3 characters from base SKU

    productionGlobalSkuProp.val(
      `${globalSKU.sku}-${globalSKU.color}${
        globalSKU.dress_size !== '' ? '-' + globalSKU.dress_size : ''
      }${globalSKU.dress_length}`
    );
    }
  }
}

// Return Color Code
async function getColorCode(current_color, colorDict = null) {
  // Utiliser le dictionnaire passé en paramètre, sinon le global, sinon un objet vide
  const dictionary = colorDict || window.color_dictionary || {};
  
  if (!dictionary) return '';
  if (current_color !== undefined) {
    const parsedColor = parseColor(current_color);
    
    if (Array.isArray(dictionary)) {
      const obj = dictionary.find(o => o.name === parsedColor);
      return obj ? obj.code : '';
    }
    
    if (dictionary[parsedColor]) {
      return dictionary[parsedColor].code || '';

    }
    
    const key = Object.keys(dictionary).find(
      k => k.toLowerCase() === parsedColor.toLowerCase()
    );
    return key ? dictionary[key].code || '' : '';
  }
  return '';
}

function parseColor(current_color) {
  if (!current_color) return '';
  
  // Si la couleur contient un slash (format "Couleur / Taille")
  if (current_color.includes('/')) {
    current_color = current_color.split('/')[0].trim();
  }
  
  // Remplacer tous les espaces par des tirets
  return current_color.replace(/\s+/g, '-').toLowerCase();
}

// Return selected Color
function getSelectedColor() {
  let element = null;

  if ($('.colorSelector').length > 0) {
    element = $('.colorSelector');
  } else if ($('.product-form__selects.product-select--color').length > 0) {
    element = $('.product-form__selects.product-select--color');
  }

  if (element) {
    if (element.hasClass('colorSelector')) {
      return element.find('.active-swatch').attr('data-colorname-value');
    } else {
      return element.find('select.single-option-selector').val();
    }
  }

  return false;
}

// Return selected Size
function getSize() {
  let select_dropdown = null;

  if ($('.infinite-option-size-select select').length > 0) {
    select_dropdown = $('.infinite-option-size-select select');
  } else {
    select_dropdown = $('.product-form__selects.product-select--size select');
  }

  if (
    select_dropdown.length > 0 &&
    select_dropdown.val() !== null &&
    select_dropdown.val() !== ''
  ) {
    return isNumber(select_dropdown.val())
      ? select_dropdown.val()
      : select_dropdown.val().toUpperCase();
  }

  return '';
}

// Validate if Size is a Number
function isNumber(n) {
  return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
}

// Return selected Dress length
function getDressLength() {
  if (
    $('.product-form__selects.product-select--dress-length select').length > 0
  ) {
    if (
      $('.product-form__selects.product-select--dress-length select').val() !==
      ''
    ) {
      return $(
        '.product-form__selects.product-select--dress-length select'
      ).val() == 'Standard'
        ? ''
        : '-XL';
    }
  }

  return '';
}
